export const rootTableClassName = 'esgi-ag-grid';
export const notSelectableClassName = 'esgi-row-not-selectable';
export const selectableClassName = 'esgi-row-selectable';
